/* Per-game server-instellingen: maps, gamemodes, standaard-commands.
   Gebruikt door ServerRegiePage om rijkere paneeltjes te tonen. */

// ============ CS 1.6 (GoldSrc / ReHLDS) ============

export const CS16_MAPS = [
  // Defusal (de_)
  'de_dust', 'de_dust2', 'de_aztec', 'de_inferno', 'de_train', 'de_nuke',
  'de_cbble', 'de_vertigo', 'de_prodigy', 'de_survivor', 'de_storm', 'de_torn',
  'de_chateau', 'de_piranesi', 'de_airstrip', 'de_westwood', 'de_tides',
  // Hostage rescue (cs_)
  'cs_assault', 'cs_office', 'cs_militia', 'cs_havana', 'cs_italy', 'cs_backalley',
  'cs_siege', 'cs_estate', 'cs_thunder', 'cs_747',
  // AWP / arena / fun
  'awp_map', 'awp_india', 'fy_iceworld', 'fy_snow', 'aim_map',
  '35hp_2', 'as_oilrig',
]

export const CS16_QUICK_CMDS = [
  { label: 'Round-restart',  cmd: 'sv_restartround 1' },
  { label: 'Reset scores',    cmd: 'mp_teamscore_1 0; mp_teamscore_2 0; sv_restartround 3' },
  { label: 'Warm-up 3 min',  cmd: 'mp_timelimit 0; sv_restartround 180' },
  { label: 'Match: 15-15',   cmd: 'mp_maxrounds 30; mp_startmoney 800; sv_restart 1' },
  { label: 'Match: 7-7',     cmd: 'mp_maxrounds 14; mp_startmoney 800; sv_restart 1' },
  { label: 'Pub: MR15',      cmd: 'mp_timelimit 30; mp_freezetime 3' },
]

export const CS16_CVARS = [
  { key: 'hostname',            label: 'Servernaam',           type: 'text' },
  { key: 'mp_timelimit',        label: 'Time-limit (min)',     type: 'number' },
  { key: 'mp_roundtime',        label: 'Round-time (min)',     type: 'number', step: '0.25' },
  { key: 'mp_freezetime',       label: 'Freeze-time (sec)',    type: 'number' },
  { key: 'mp_maxrounds',        label: 'Max rounds',           type: 'number' },
  { key: 'mp_startmoney',       label: 'Start money',          type: 'number' },
  { key: 'mp_buytime',          label: 'Buy-time (min)',       type: 'number', step: '0.25' },
  { key: 'mp_c4timer',          label: 'C4 timer (sec)',       type: 'number' },
  { key: 'mp_friendlyfire',     label: 'Friendly fire',        type: 'bool' },
  { key: 'mp_autoteambalance',  label: 'Auto team balance',    type: 'bool' },
  { key: 'mp_footsteps',        label: 'Footsteps',            type: 'bool' },
  { key: 'mp_flashlight',       label: 'Flashlights',          type: 'bool' },
  { key: 'sv_password',         label: 'Server password',      type: 'text' },
  { key: 'sv_cheats',           label: 'Cheats',               type: 'bool' },
]

// ============ Quake 3 Arena ============

export const Q3A_MAPS = [
  // Free-For-All Deathmatch
  'q3dm0', 'q3dm1', 'q3dm2', 'q3dm3', 'q3dm4', 'q3dm5', 'q3dm6', 'q3dm7',
  'q3dm8', 'q3dm9', 'q3dm10', 'q3dm11', 'q3dm12', 'q3dm13', 'q3dm14', 'q3dm15',
  'q3dm16', 'q3dm17', 'q3dm18', 'q3dm19',
  // Tournament
  'q3tourney1', 'q3tourney2', 'q3tourney3', 'q3tourney4', 'q3tourney5', 'q3tourney6',
  // Capture The Flag
  'q3ctf1', 'q3ctf2', 'q3ctf3', 'q3ctf4', 'q3ctf5', 'q3ctf6', 'q3ctf7', 'q3ctf8',
]

export const Q3A_GAMEMODES = [
  { value: '0', label: 'Free-For-All Deathmatch' },
  { value: '1', label: 'Tournament (1v1)' },
  { value: '3', label: 'Team Deathmatch' },
  { value: '4', label: 'Capture The Flag' },
]

export const Q3A_QUICK_CMDS = [
  { label: 'Restart map',      cmd: 'map_restart' },
  { label: 'Volgende map',     cmd: 'nextmap' },
  { label: 'Warm-up 60s',      cmd: 'g_warmup 60' },
  { label: 'Ready-up all',     cmd: 'exec ready.cfg' },
]

export const Q3A_CVARS = [
  { key: 'sv_hostname',    label: 'Servernaam',        type: 'text' },
  { key: 'g_gametype',     label: 'Gametype',          type: 'select', options: Q3A_GAMEMODES },
  { key: 'fraglimit',      label: 'Frag-limit',        type: 'number' },
  { key: 'timelimit',      label: 'Time-limit (min)',  type: 'number' },
  { key: 'capturelimit',   label: 'Capture-limit',     type: 'number' },
  { key: 'g_forcerespawn', label: 'Force respawn (sec)', type: 'number' },
  { key: 'sv_maxclients',  label: 'Max clients',       type: 'number' },
  { key: 'g_password',     label: 'Server password',   type: 'text' },
]

// ============ MOHAA (Medal of Honor: Allied Assault) ============

export const MOHAA_MAPS = [
  // Deathmatch (mohdm)
  'dm/mohdm1', 'dm/mohdm2', 'dm/mohdm3', 'dm/mohdm4', 'dm/mohdm5', 'dm/mohdm6', 'dm/mohdm7',
  // Objective
  'obj/obj_team1', 'obj/obj_team2', 'obj/obj_team3', 'obj/obj_team4',
  // Round-based (custom-vaak-gebruikt)
  'obj/obj_team1_pillbox', 'obj/obj_team2_algiers', 'obj/obj_team3_sicily', 'obj/obj_team4_stalingrad',
]

export const MOHAA_GAMEMODES = [
  { value: '0', label: 'Free-For-All' },
  { value: '1', label: 'Team-Match' },
  { value: '2', label: 'Round-Based' },
  { value: '3', label: 'Objective' },
  { value: '4', label: 'Tug-of-War' },
  { value: '5', label: 'Liberation' },
]

export const MOHAA_QUICK_CMDS = [
  { label: 'Restart map',    cmd: 'restart' },
  { label: 'Volgende map',   cmd: 'exec autoexec.cfg' },  // afhankelijk van cfg
]

export const MOHAA_CVARS = [
  { key: 'sv_hostname',    label: 'Servernaam',       type: 'text' },
  { key: 'g_gametype',     label: 'Gametype',         type: 'select', options: MOHAA_GAMEMODES },
  { key: 'fraglimit',      label: 'Frag-limit',       type: 'number' },
  { key: 'timelimit',      label: 'Time-limit (min)', type: 'number' },
  { key: 'sv_maxclients',  label: 'Max clients',      type: 'number' },
  { key: 'sv_password',    label: 'Server password',  type: 'text' },
]

// ============ UT2004 (Unreal Tournament 2004) ============

export const UT2004_MAPS = [
  // Deathmatch
  'DM-Antalus', 'DM-Rankin', 'DM-Deck17', 'DM-Curse4', 'DM-Ironic',
  'DM-1on1-Roughinery', 'DM-DE-Grendelkeep', 'DM-Gael', 'DM-Metallurgy',
  'DM-Morpheus3', 'DM-Corrugation', 'DM-Injector', 'DM-Insidious', 'DM-Leviathan',
  'DM-Plunge', 'DM-Sulphur', 'DM-TokaraForest', 'DM-TrainingDay',
  // CTF
  'CTF-Face3', 'CTF-Grendelkeep', 'CTF-BridgeOfFate', 'CTF-Chrome', 'CTF-Citadel',
  'CTF-Colossus', 'CTF-DoubleDammage', 'CTF-Geothermal', 'CTF-Grassyknoll',
  'CTF-Maul', 'CTF-Orbital2', 'CTF-Smote',
  // Onslaught
  'ONS-Torlan', 'ONS-Primeval', 'ONS-Dawn', 'ONS-Dria', 'ONS-FrostBite',
  'ONS-Severance', 'ONS-Urban',
  // Assault
  'AS-Convoy', 'AS-RobotFactory', 'AS-Junkyard', 'AS-MotherShip', 'AS-Glacier',
  // Bombing Run
  'BR-Anubis', 'BR-Bifrost', 'BR-Colossus', 'BR-Serenity', 'BR-Skyline',
  // Double Domination
  'DOM-Access', 'DOM-Atlantis', 'DOM-Aswan', 'DOM-Junkyard', 'DOM-SepukkuGorge',
]

export const UT2004_GAMETYPES = [
  { value: 'XGame.xDeathMatch',         label: 'DeathMatch' },
  { value: 'XGame.xTeamGame',           label: 'Team DeathMatch' },
  { value: 'XGame.xCTFGame',            label: 'Capture The Flag' },
  { value: 'XGame.xVehicleCTFGame',     label: 'Vehicle CTF' },
  { value: 'Onslaught.ONSOnslaughtGame', label: 'Onslaught' },
  { value: 'XGame.xBombingRun',         label: 'Bombing Run' },
  { value: 'XGame.xDoubleDom',          label: 'Double Domination' },
  { value: 'UT2k4Assault.ASGameInfo',   label: 'Assault' },
]

export const UT2004_QUICK_CMDS = [
  { label: 'Restart level',  cmd: 'restart' },
  { label: 'Volgende map',   cmd: 'servertravel ?nextmap' },
  { label: 'Bots aan',       cmd: 'setbots 4' },
]

export const UT2004_CVARS = [
  { key: 'ServerName',   label: 'Servernaam',      type: 'text' },
  { key: 'GamePassword', label: 'Server password', type: 'text' },
  { key: 'AdminPassword', label: 'Admin password', type: 'text' },
  { key: 'MaxPlayers',   label: 'Max players',     type: 'number' },
  { key: 'GoalScore',    label: 'Goal score',      type: 'number' },
  { key: 'TimeLimit',    label: 'Time-limit (min)', type: 'number' },
]
